import { Component, effect, inject } from '@angular/core';
import { CurrencyService } from '../currency.service';
import { CurrencyRepository } from '@/store/currency-state/currency-state.repository';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { getCurrencyHistoryDataTableStructure } from './utils/currency-history-data-table-object';
import { CurrencyHistory } from '@/types';
import { PageHeaderComponent } from '@/components/shared/page-header/page-header.component';
import { DataTableBuilderComponent } from '@/components/data-table-builder/data-table-builder.component';
import { DatePicker } from 'primeng/datepicker';
import { CommonModule } from '@angular/common';
import { DateFieldProps, DynamicField, FieldVariant } from '@/components/form-builder/form-builder.types';
import { FormsModule } from '@angular/forms';
import { map, of } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { DynamicDataTable } from '@/components/data-table-builder/data-table.types';
import { createServerQuery } from '@/components/data-table-builder/server-query';

@Component({
  selector: 'sm-currency-history',
  imports: [PageHeaderComponent, DataTableBuilderComponent, DatePicker, CommonModule, TranslateModule, FormsModule],
  templateUrl: './currency-history.component.html',
  styleUrl: './currency-history.component.scss',
})
export class CurrencyHistoryComponent {
  currencyService = inject(CurrencyService);
  currencyRepository = inject(CurrencyRepository);
  translate = inject(TranslateService);
  messageService = inject(MessageService);
  activatedRoute = inject(ActivatedRoute);

  breadcrumb = [
    {
      label: 'settings.currency.breadcrumb.parametres',
      routerLink: ['/settings'],
    },
    {
      label: 'settings.currency.breadcrumb.currency',
      routerLink: ['/settings', 'currency'],
    },
    {
      label: 'settings.currency.breadcrumb.history',
      routerLink: ['/settings', 'currency', 'history'],
    },
  ];
  serverQuery = createServerQuery({});

  dataTableObject: DynamicDataTable = getCurrencyHistoryDataTableStructure({
    serverQuery: this.serverQuery,
  });
  loading = false;

  data: CurrencyHistory[] = [];
  date!: string;

  totalRecords = 0;
  id = Number(this.activatedRoute.snapshot.paramMap.get('id'));

  dateField: DynamicField<DateFieldProps> = {
    label: 'settings.currency.history.filters.date.label',
    variant: FieldVariant.DATE,
    props: {
      value: of(this.date).pipe(map(date => (date ? new Date(date) : null))),
      view: 'date',
      onChange: (date: Date) => {
        this.changeDate(date);
      },
    },
  };

  constructor() {
    effect(() => {
      const page = this.serverQuery.page();
      const size = this.serverQuery.pageSize();
      const sortBy = this.serverQuery.sortBy();
      const sortOrder = this.serverQuery.sortOrder();
      const search = this.serverQuery.search();
      const sort = sortBy ? `${sortBy},${sortOrder}` : 'id,desc';
      this.loadData(page, size, sort, search);
    });
  }
  changeDate(date: Date) {
    this.date = date ? date.toISOString() : '';

    this.loadData();
  }

  loadData(page = 0, size = 10, sort?: string, search?: string) {
    this.loading = true;
    this.currencyService.getCurrencyHistory({ page, size, sort, search }, this.date).subscribe({
      next: res => {
        this.data = res.content;
        this.totalRecords = res.totalElements;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: this.translate.instant('settings.currency.message.error.loading'),
        });
      },
    });
  }
}
